import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultFieldProps, FieldBase } from './FieldBase';
import { get } from '../../utils/Request';
import { useConfig } from '../../ConfigContext';

interface Options {
  name: string;
  value: string;
}

export function CountryInput({ name = 'country', ...props }: DefaultFieldProps): JSX.Element {
  const { t } = useTranslation();
  const [field, meta] = useField({ name });
  const config = useConfig();

  const [countriesOptions, setCountriesOptions] = useState<Options[]>([]);

  const createCountriesOptions = (countries: string[]): void => {
    const co: Options[] = [];
    countries.forEach((value) => {
      co.push({ name: t(`countries.code.${value}`), value });
    });

    co.sort((a, b) => Intl.Collator().compare(a.name, b.name));
    setCountriesOptions(co);
  };

  // Get countries
  useEffect(() => {
    get<string[]>(`${config.clientConfig?.host}/countries`).then((countries) => {
      createCountriesOptions(countries);
    });
  }, [t]);

  return (
    <FieldBase name={name} meta={meta}>
      <select
        id={name}
        data-cy={`${name}-form`}
        className={`form-control 
        ${(meta.error && meta.touched) ? 'is-invalid' : ''}`}
        disabled={props.disabled}
        {...field}
      >
        <option value='' aria-label='Empty' />
        {countriesOptions.map((item) => (
          <option value={item.value} key={`${item.value}`}>
            {item.name}
          </option>
        ))}
      </select>
    </FieldBase>
  );
}
